import { call, put, select, takeLatest } from 'redux-saga/effects';
import api from '../../utils/api';
import { toastResponseError } from '../../utils/responseMessageHelper';
import {
  GET_HOME_ARTICLE,
  GET_HOME_SECTIONS,
  putHomeArticle,
  putHomeArticleFinishFetch,
  putHomeArticleStartFetch,
  putHomeFinishFetch,
  putHomeSectionContent,
  putHomeSectionContentsLoaded,
  putHomeSections,
  putHomeStartFetch,
} from '../reducers/home';
import { authSelectLocale } from '../selectors/globalSelectors';
import {
  homeSelectLoading,
  homeSelectLocaleLoaded,
} from '../selectors/homeSelectors';
import { loadKBTree } from './kbTreeLoader';

const HOME_KB_CONFIG = {
  apiFns: {
    getSections: api.home.getHomeSections,
    getSectionContent: api.home.getHomeSectionContent,
  },
  actions: {
    putSections: putHomeSections,
    putSectionContent: putHomeSectionContent,
    putContentsLoaded: putHomeSectionContentsLoaded,
  },
};

/* worker-saga */
function* onGetHomeSections() {
  try {
    const currentLocale = yield select(authSelectLocale);
    const localeLoaded = yield select(homeSelectLocaleLoaded);
    const isLoading = yield select(homeSelectLoading);

    if (currentLocale && currentLocale !== localeLoaded && !isLoading) {
      yield put(putHomeStartFetch());
      yield* loadKBTree({ ...HOME_KB_CONFIG, currentLocale });
    }
  } catch (response) {
    yield put(putHomeFinishFetch());
    toastResponseError(response);
  }
}

function* onGetHomeArticle({ payload: { sectionCode, articleCode } }) {
  try {
    const currentLocale = yield select(authSelectLocale);

    if (!currentLocale || !sectionCode || !articleCode) {
      return;
    }

    yield put(putHomeArticleStartFetch());

    const response = yield call(api.home.getHomeArticle, {
      currentLocale,
      sectionCode,
      articleCode,
    });

    yield put(
      putHomeArticle({
        sectionCode,
        article: response.get('data'),
      }),
    );
    yield put(putHomeArticleFinishFetch());
  } catch (response) {
    yield put(putHomeArticleFinishFetch());
    toastResponseError(response);
  }
}

/* watcher-saga */
function* watchHomeActions() {
  yield takeLatest(GET_HOME_SECTIONS, onGetHomeSections);
  yield takeLatest(GET_HOME_ARTICLE, onGetHomeArticle);
}

export default watchHomeActions;
